import ga from "@store/Framework/Common/GoogleAnalytics";

const mapProductInfosOption = (
    options: Toolkit.GoogleAnalytics.Options | undefined,
    id: string | null,
    ignorePricing?: boolean,
) => {
    const productInfo = options?.productInfos?.find(x => x.productId === id);

    if (!productInfo) {
        return {};
    }

    const { inventory, pricing, qtyOrdered, unitOfMeasure } = productInfo;
    const availability = ga.util.getAvailability(inventory, unitOfMeasure);

    const data: Toolkit.GoogleAnalytics.Item = {
        quantity: qtyOrdered || undefined,
        stock_id: availability?.messageType ?? undefined,
        stock_status: availability?.message || undefined,
        unit_of_measure: unitOfMeasure || undefined,
    };

    if (!ignorePricing && pricing) {
        Object.assign(data, {
            ...ga.util.getItemDiscountParameters(pricing.unitListPrice, pricing.unitNetPrice),
            price: ga.util.parseAmount(pricing.unitNetPrice),
        });
    }

    return data;
};

export default mapProductInfosOption;
